import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { RegionCrudService } from 'src/app/shared/services/region-crud.service';
import { Region } from 'src/app/shared/interfaces/region';

@Component({
  selector: 'app-regions',
  templateUrl: './regions.component.html',
  styleUrls: ['./regions.component.scss']
})
export class RegionsComponent implements OnInit {

  regions: Region[];
  region: Region;
  selectedRegions: Region[] = [];

  regionDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private regionService : RegionCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Regions'}
    ];

    this.regions = [];
    this.region = { } as Region ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.regionService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.regions = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Region = jsonItem as Region;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.regions.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.regionService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.regions);
            doc.save('regions.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.regions);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "regions");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedRegions);
      // console.log('SAVEC CSV LOCATIONS ', this.regions);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedRegions, 'regions', exportCols);
   // this.exportService.exportToCsv(this.regions, 'regions', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.region = {} as Region;
    this.submitted = false;
    this.regionDialog = true;
  }

  deleteSelectedRegions() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected regions?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.regions = this.regions.filter(val => !this.selectedRegions.includes(val));
            
            this.selectedRegions.forEach( region => this.regionService.delete(region.$key));
            this.selectedRegions = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Regionss Deleted', life: 3000});
        }
    });
  }

  editRegion(region: Region) {
    this.region = {...region};
    this.regionDialog = true;
  }

  deleteRegion(region: Region) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + region.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.regions = this.regions.filter(val => val.$key !== region.$key);
            this.region = {} as Region;
            this.regionService.delete(region.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Region Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.regionDialog = false;
    this.submitted = false;
  }

  saveRegion() {
    this.submitted = true;

    if ( this.region.name.trim() ) {
      this.region.isEnabled = true;

      if (this.region.$key) {
          this.regions[this.findIndexById(this.region.$key)] = this.region;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Region Updated', life: 3000});
          this.regionService.update(this.region);
        } else {
          this.region.position = this.regions.length;
          this.regionService.add(this.region);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Region Created', life: 3000});
      this.regions = [...this.regions];
    }

    this.regionDialog = false;
    this.region = { } as Region;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.regions.length; i++) {
        if (this.regions[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeRegion(region : Region) {
    //console.log("SAVE", region);
    this.regionService.update(region);
  }

  completePosition(region : Region) {
   // console.log("SAVE", region);
  //  this.regionService.updateRegion(region);


    if ( this.newPosition > -1 ) {
        region.position = this.newPosition;
        region = this.checkPositionLimits(region);
        this.reorderElements(region);
        //this.updateDB(region);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.regions);
    // const myClonedArray = [];
    // this.regions.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.regions.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.regions.length - 1 - event.dropIndex;
    const regionToMove = this.regions[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.regions[index] = this.regions[index+1];
        this.regions[index].position = index;
        this.regionService.update(this.regions[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.regions[index] = this.regions[index-1];
        this.regions[index].position = index;
        this.regionService.update(this.regions[index]);
      }
    } 
    this.regions[endIndex] = regionToMove;
    this.regions[endIndex].position = endIndex;
    this.regionService.update(this.regions[endIndex]);
  }

  // onFieldEdit(region: Spray, fieldName: string): void {
  //   //console.log(this.regions);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + region[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       region.position = this.newPosition;
  //       region = this.checkPositionLimits(region);
  //       this.reorderElements(region);
  //       //this.updateDB(region);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(region);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.regions.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, region: Region) {
    // console.log("event" +event);
    if (region.position != null && region.position > -1) {
      this.previousPosition = region.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(region: Region) {
    console.log('check ',region.position + ' ' + this.regions.length);
    if (!region.position) {
     // console.log('check 1');
      return this.region;
    }
    if (region.position < 0) {
      region.position = 0;
      // console.log('check 2');
      return region;
    }
    if (region.position > this.regions.length) {
      region.position = this.regions.length - 1;
    //  console.log('check 3', region.position);
      return region;
    }
   // console.log('check 4');
    return region;
  }

  async reorderElements(region: Region) {
    this.newPosition = this.newPosition  > this.regions.length ? this.regions.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === region.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const regionToMove = this.regions[startIndex];
   // console.log('Item to move: ', this.regions[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.regions);
        console.log('Item to +1: ', this.regions[index+1]);

        this.regions[index] = this.regions[index+1];
        this.regions[index].position = index;
        // console.log('Move: ', this.regions[index+1]);
        // console.log('Move pos: ', this.regions[index].position);
        //await this.updateDB(this.regions[index]);
        this.regionService.update(this.regions[index]);
     //   console.log('Update DB: ', this.regions[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.regions[index] = this.regions[index-1];
        this.regions[index].position = index;
        this.regionService.update(this.regions[index]);
      }
    } 
    this.regions[endIndex] = regionToMove;
    this.regions[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.regionService.update(this.regions[endIndex]);
    
    // const myClonedArray = [];
    // this.regions.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.regions = myClonedArray;
   // this.getAllRecords();
  }
}
